import React, { useReducer } from 'react';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import { Alert } from 'react-bootstrap';

import { AccountContentContainer, HeadlineCTA } from './common';
import { Form, FormRow } from '../Design/form';
import Button from '../UI/Button/Button';
import FormGroup from './common/FormGroup';
import Box from '../_styles/Box';
import {
  resetPasswordConfirm,
  resetPasswordReducer,
  resetPasswordInitialState,
} from './reducers/resetPasswordReducer';

import * as authActions from '../../actions/auth/actions';

function ResetPassword({
  handleSubmit,
  logout,
  history,
  isLoggedIn,
  ...props
}) {
  const [state, dispatch] = useReducer(
    resetPasswordReducer,
    resetPasswordInitialState
  );

  const onFormSubmit = ({ password }) => {
    const { uid, token } = props.match.params;

    resetPasswordConfirm({
      uid,
      token,
      password,
      history,
      dispatch,
      isLoggedIn,
      logout,
    });
  };

  return (
    <AccountContentContainer>
      <HeadlineCTA
        headlineText="Reset Password"
        subtext="Please enter your new password. Changing your password will log you out of all browsers."
      />

      <Form onSubmit={handleSubmit(onFormSubmit)}>
        <FormRow>
          <Field
            component={FormGroup}
            type="password"
            label="Your password"
            name="password"
            placeholder="Enter your password here."
          />
        </FormRow>
        
        <FormRow>
          <Field
            component={FormGroup}
            type="password"
            label="Confirm your password"
            name="confirmPassword"
            placeholder="Confirm password here"
          />
        </FormRow>

        <FormRow>
          <Button type="submit" primary block loading={state.isSubmitting}>
            {state.hasSubmitted ? 'Done!' : 'Submit'}
          </Button>
        </FormRow>
      </Form>

      {state.hasError && state.errors.length > 0 && (
        <Box mt={30}>
          <Alert variant="danger">
            {state.errors.map((error, index) => (
              <div key={index}>{error || "Something went wrong. Please try again later."}</div>
            ))}
          </Alert>
        </Box>
      )}
    </AccountContentContainer>
  );
}

function validate({ password, confirmPassword }) {
  const errors = {};

  if (!password) {
    errors.password = "Password is required";
  } else {
    if (password.length < 8) {
      errors.password = "Password must be at least 8 characters long";
    } else if (!/[A-Z]/.test(password)) {
      errors.password = "Password must contain at least one uppercase letter";
    } else if (!/[0-9]/.test(password)) {
      errors.password = "Password must contain at least one number";
    } else if (!/[!@#$%^&*(),.?\":{}|<>]/.test(password)) {
      errors.password = "Password must contain at least one symbol";
    }
  }

  if (!confirmPassword) {
    errors.confirmPassword = "Confirm password is required";
  } else if (password !== confirmPassword) {
    errors.confirmPassword = "Passwords don't match";
  }

  return errors;
}

const form = reduxForm({
  form: 'reset-password',
  fields: ['password', 'confirmPassword'],
  validate,
})(ResetPassword);

function mapStateToProps(state) {
  const { isLoggedIn } = state.auth;

  return {
    isLoggedIn,
  };
}

export default connect(mapStateToProps, authActions)(form);
